export const formatStringToDisplay = (str, char) => {
    if (str) {
        let newStr = str.split(char).join(" ");
        newStr = newStr.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        return newStr;
        
    }
    return str;
}

export const formatStringWithToUpperCase = (str) => {
    if (str) {
        let newStr = str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        return newStr;
    }
    return str;
}